import { gql } from '@apollo/client'

export const CREATE_CHATROOM_META = gql`
  mutation CreateChatRoomMeta($input: CreateChatRoomMetaByIdInput!) {
    createChatRoomMeta(input: $input) {
      id
    }
  }
`
export const DELETE_CHATROOM_META = gql`
  mutation DeleteChatRoomMeta($input: ChatroomMetaDeletePayload!) {
    deleteChatRoomMeta(input: $input) {
      id
    }
  }
`

export const UPDATE_CHATROOM_META_BY_ID = gql`
  mutation UpdateChatRoomMetaById($input: UpdateChatRoomMetaByIdInput!) {
    updateChatRoomMetaById(input: $input) {
      id
    }
  }
`